export default __webpack_public_path__ + "static/media/coins.544c21c0.jpeg";